var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoteControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86231 7.94992C1.36701 7.75731 1.11937 7.661 1.04707 7.52223C0.984391 7.40193 0.984306 7.25863 1.04684 7.13826C1.11898 6.9994 1.36651 6.9028 1.86158 6.70961L15.9112 1.22683C16.3581 1.05243 16.5816 0.965227 16.7243 1.01293C16.8483 1.05435 16.9456 1.15166 16.9871 1.27566C17.0348 1.41845 16.9476 1.6419 16.7732 2.0888L11.2904 16.1384C11.0972 16.6335 11.0006 16.881 10.8617 16.9532C10.7414 17.0157 10.5981 17.0156 10.4778 16.9529C10.339 16.8806 10.2427 16.633 10.0501 16.1377L7.86364 10.5154C7.82455 10.4149 7.805 10.3646 7.7748 10.3223C7.74804 10.2848 7.71523 10.252 7.67771 10.2252C7.63538 10.195 7.58511 10.1755 7.48457 10.1364L1.86231 7.94992Z",
    stroke: "#363BC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteControl);
export default __webpack_public_path__ + "static/media/remoteControl.715e2de4cb4bd8d3796911e6f2d41514.svg";
export { ForwardRef as ReactComponent };